import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "flex flex-col"
};
const _hoisted_2 = {
  class: "flex flex-col"
};
const _hoisted_3 = {
  class: "text-2xl pl-3 hover:pl-4 cursor-pointer transition-all"
};
const _hoisted_4 = {
  key: 0,
  class: "bg-gray-900 min-h-[1vh] ml-1"
};
const _hoisted_5 = {
  key: 0,
  class: "bg-gray-900 min-h-[3vh] ml-1"
};
import { ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'FlodableContainer',
  props: {
    title: {}
  },
  setup(__props) {
    const props = __props;
    const expand = ref(false);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "text-gray-900 bg-gray-200 items-center flex cursor-pointer pl-2",
        onClick: _cache[0] || (_cache[0] = $event => expand.value = !expand.value)
      }, [_createElementVNode("span", {
        class: _normalizeClass(["text-2xl transition-all", expand.value ? 'rotate-90' : 'rotate-0'])
      }, "▶", 2), _createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1)])]), !expand.value ? (_openBlock(), _createElementBlock("div", _hoisted_4)) : _createCommentVNode("", true), _createVNode(_Transition, {
        name: "fade"
      }, {
        default: _withCtx(() => [expand.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_renderSlot(_ctx.$slots, "default")])) : _createCommentVNode("", true)]),
        _: 3
      })]);
    };
  }
});